export default "__VITE_ASSET__DX9$sC4s__"